import { render, staticRenderFns } from "./InspectItem.vue?vue&type=template&id=effa7602&scoped=true&"
import script from "./InspectItem.vue?vue&type=script&lang=js&"
export * from "./InspectItem.vue?vue&type=script&lang=js&"
import style0 from "./InspectItem.vue?vue&type=style&index=0&id=effa7602&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effa7602",
  null
  
)

export default component.exports